import React from 'react'
import "./join.css"
import TopBar from '../TopBar/TopBar'
import Footer from '../Footer/Footer'
import Foot2 from '../Foot2/Foot2'

const Join = () => {
  return (
    <>
      <TopBar />
    <div className='join'>
      
        <div className="submit">Submit Your Email To Join Nairaland</div>
        <div className="sec1">Before you can join Nairaland, we need to verify your email. Please enter it below:</div>
      
       <form><div className="form1">
         
          <label htmlFor="email">E-mail: </label><input style={{ 'background-color': "white" }} type="email" id='email' />
        </div>
        <button>Submit</button></form>
      
      <div className="joinfoot"><span className='beneath'>(Go Up)</span> <Foot2 /> </div>
     
    </div>
    
    </>
  )
}

export default Join